import LocalizedStrings from 'localized-strings';

interface SelectToBankAccountLocales {
  toAccount: string;
}

const locales = new LocalizedStrings<SelectToBankAccountLocales>({
  en: {
    toAccount: 'Transfer to',
  },
  fr: {
    toAccount: 'Transférer vers',
  },
} as const);

export default locales;
